import { Suspense, useEffect } from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { getRoutes } from "./Routes";
import PrivateRoute from "./PrivateRoutes";
import Sidebar from "../components/Sidebar/Sidebar";
import MobileSidebar from "../components/Sidebar/MobileSidebar";
import Footer from "../components/Footer/Footer";
import { CommonMessageProvider } from "../common/CommonMessage";

const AppRoutes = () => {
  const routes = getRoutes();
  const navigate = useNavigate();
  const location = useLocation();

  const token = localStorage.getItem("token");

  useEffect(() => {
    const isOnRoot = location.pathname === "/";
    const isOnPrivatePath = routes.some(
      (route) => route.isPrivate && route.path === location.pathname
    );

    if (token && isOnRoot) {
      navigate("/dashboard");
    } else if (!token && isOnPrivatePath) {
      navigate("/");
    }
  }, [token, location.pathname, routes, navigate]);

  return (
    <CommonMessageProvider>
      <Suspense>
        <Routes>
          {routes.map((route, index) => (
            <Route
              path={route?.path}
              key={"route_" + index}
              element={
                route?.isLayout && route.isPrivate ? (
                  <PrivateRoute redirectPath="/">
                    <Sidebar />
                    <div className="rightSide">
                      <MobileSidebar />
                      <route.element />
                      <Footer />
                    </div>
                  </PrivateRoute>
                ) : !route?.isLayout && route.isPrivate ? (
                  <PrivateRoute redirectPath="/">
                    <route.element />
                  </PrivateRoute>
                ) : (
                  <route.element />
                )
              }
            />
          ))}
        </Routes>
      </Suspense>
    </CommonMessageProvider>
  );
};

export default AppRoutes;
